import SectionContainer from "../../components/UI/SectionContainer";
import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { openAlert } from "../../utils/common";
import Spinner from "../../components/UI/Spinner";
import userService from "../../services/userService";
import { useConfig } from "../../context/ConfigContext";

const UserProfilePage = () => {
    const { userIdx } = useParams();
    const { diabetesKindMap } = useConfig();
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState({});

    console.log(diabetesKindMap);
    
    const fetchProfile = useCallback(async (userIdxArg) => {
        setLoading(true);
        try{
            const result = await userService.getUserDetail(userIdxArg);
            if(!result.success) {
                openAlert({ title: '알림', description: result.message });
                return;
            }
            if(!result.data?.userIdx) {
                openAlert({ title: '알림', description: '올바른 접근이 아닙니다.'});
                return;
            }
            setProfile(result.data);
        }catch(e){
            const errorMessage = e.response?.data?.message || e.message || '데이터 로드 중 오류가 발생했습니다.';
            openAlert({ title: '알림', description: errorMessage });
        }finally{
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if(userIdx === undefined){
            openAlert({ title: '알림', description: '올바른 접근이 아닙니다.2'});
            return;
        }
        fetchProfile(userIdx);
    }, [userIdx, fetchProfile]);
    
    return (
        <SectionContainer title="회원정보">
            <Spinner visible={loading}/>
            <div className="account_content">
                <div className="content_area con01">
                    <div className="popup_table_area">
                        <div className="table dl-wrap">
                            <div className="popup_info_h3 mb-1"><h3>가입정보</h3></div>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>아이디</p></dt>
                                <dd className="dl-box-body"><p>{profile?.userId || ''}</p></dd>
                            </dl>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>성명</p></dt>
                                <dd className="dl-box-body"><p>{profile?.userName || ''}</p></dd>
                            </dl>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>이메일</p></dt>
                                <dd className="dl-box-body"><p>{profile?.userEmail || ''}</p></dd>
                            </dl>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>성별</p></dt>
                                <dd className="dl-box-body"><p>{profile?.gender === 1 ? '남성' : '여성'}</p></dd> {/* 남성 */}
                            </dl>
                        </div>
                    </div>
                    <div className="popup_table_area mt-3">
                        <div className="table dl-wrap">
                            <div className="popup_info_h3 mb-1"><h3>개인정보</h3></div>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>생년월일</p></dt>
                                <dd className="dl-box-body"><p>{profile?.birthday || ''}</p></dd>
                            </dl>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>키/몸무게</p></dt>
                                <dd className="dl-box-body"><p>{profile?.height || ''}cm / {profile?.weight || ''}kg</p></dd>
                            </dl>
                            <dl className="dl-box">
                                <dt className="dl-box-head"><p>당뇨구분</p></dt>
                                <dd className="dl-box-body"><p>{diabetesKindMap[profile?.diabetesKind] || ''}</p></dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            
        </SectionContainer>
    );
}

export default UserProfilePage;